import { render, staticRenderFns } from "./AcceptanceForm.vue?vue&type=template&id=34b96a4e&"
import script from "./AcceptanceForm.vue?vue&type=script&lang=ts&"
export * from "./AcceptanceForm.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptanceForm.vue?vue&type=style&index=0&id=34b96a4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports